import { bindActionCreators } from "@reduxjs/toolkit";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import ItemGroupsActions from "../../../store/actions/items/categories/itemGroups/itemGroups.actions";
import { useEffect, useState } from "react";
import HeaderItemGroupsNavLinksComponent from "./HeaderItemGroupsNavLinksComponent";
import HeaderLogoComponent from "./HeaderLogoComponent";

import "../../../styles/layouts/header/_header.scss";
import useMobileScreen from "../../../hooks/useMobileScreen";
import ShoppingCartHeaderIconComponent from "./shoppingCart/ShoppingCartHeaderIconComponent";
import useAccount from "../../../hooks/useAccount";
import HeaderSearchComponent from "./HeaderSearchComponent";

export const HeaderComponent = ({}) => {
  const isMobileScreen = useMobileScreen();
  const { isLoggedIn, logout, userInfo } = useAccount();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isSearchOpen, setIsSearchOpen] = useState(false);

  const toggleOpenNavMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const handleHamburgerMenuClicked = () => {
    toggleOpenNavMenu(!isMenuOpen);
  };

  const showHeaderContentContainer = () => {
    if (isMobileScreen == false) return true;
    return isMenuOpen;
  };

  const getHamburgerMenuElement = () => {
    const element = (
      <div className="hamburgerMenu" onClick={handleHamburgerMenuClicked}>
        <i className="fa-solid fa-bars"></i>
      </div>
    );
    return isMobileScreen ? element : null;
  };

  const getHeaderContentContainerElement = () => {
    if (!showHeaderContentContainer()) return null;
    const headerContentProps = { toggleOpenNavMenu };

    return (
      <div className="headerContentContainer">
        <HeaderItemGroupsNavLinksComponent props={headerContentProps} />
      </div>
    );
  };

  const getLoginLinkElement = () => {
    if (isLoggedIn) {
      return (
        <div className="logout" onClick={logout}>
          <i className="fa-solid fa-right-from-bracket"></i>
        </div>
      );
    } else {
      return (
        <Link to="?d=account&action=login">
          <i className="fa-solid fa-user"></i>
        </Link>
      );
    }
  };

  const getShoppingCartLinkElement = () => {
    if (!isLoggedIn) return null;
    return <ShoppingCartHeaderIconComponent />;
  };

  const getSearchElement = () => {
    if (!isMobileScreen) return <HeaderSearchComponent />;

    return (
      <span className="searchIcon">
        <i className="fa-solid fa-magnifying-glass " onClick={() => setIsSearchOpen((prev) => !prev)}></i>
      </span>
    );
  };

  return (
    <header className="headerContainer">
      {getHamburgerMenuElement()}
      <HeaderLogoComponent />
      {getHeaderContentContainerElement()}
      <div className="generalLinksContainer">
        {getSearchElement()}
        {getLoginLinkElement()}
        {getShoppingCartLinkElement()}
      </div>
      {isMenuOpen && <div className="fullScreen" onClick={toggleOpenNavMenu}></div>}
      {isMobileScreen && isSearchOpen && <HeaderSearchComponent />}
    </header>
  );
};

const mapDispatchToProps = (dispatch) => {
  return {
    categoryActions: bindActionCreators(ItemGroupsActions, dispatch),
  };
};

export default connect(null, mapDispatchToProps)(HeaderComponent);
